// Loads all favicon images
const importAll = (requireContext) => requireContext.keys().forEach(requireContext);

importAll(require.context('.', true, /\.png$/));
importAll(require.context('.', true, /\.ico$/));
importAll(require.context('.', true, /favicon\.svg$/));
importAll(require.context('.', true, /safari-pinned-tab\.svg$/));
